/*
  nav
*/
/**
 * Desktop/Mobile nav bar management
 */

/************************************************
		Check on WL or CB side and switch links accordingly
*************************************************/

//-- get all nav bar links & switch between CB or WL link (MOBILE & DESKTOP)
$(".desk_hdr_nav_categories a[data-href-wl][data-href-cb], [class^=mob_cat_list] a[data-href-wl][data-href-cb]").each(function() {

  if (isCashbackSite()) {
    $(this).attr("href", $(this).attr("data-href-cb"));
  }
  else {
    var _wl_link = $(this).attr("data-href-wl");

    //-- if empty link, hide the element
    if ($.trim(_wl_link) === '') {
      $(this).hide();
    }
    else {
      $(this).attr("href", _wl_link);
    }
  }
});



/**
 * isCashbackSite - check if current url is a cashback url
 * @return {BOOL}
 */
function isCashbackSite() {
  var current_url = window.location.href;
  return current_url.match(/(cashback.)/);
}

/**
 * isStage - check if current url is a stage url
 * @return {BOOL}
 */
function isStage() {
  var current_url = window.location.href;
  return current_url.match(/(stage.|staging.)/);
}

/**
 * isQa - check if current url is a qa url
 * @return {BOOL}
 */
function isQa() {
  var current_url = window.location.href;
  return current_url.match(/(qa.)/);
}

/**
 * isQaGl - check if current url is a qa-gl url
 * @return {BOOL}
 */
function isQaGl() {
  var current_url = window.location.href;
  return current_url.match(/(qa-gl.)/);
}

/**
 * pickSiteRoot - get current site domain (using nav urls)
 * @return {BOOL}
 */
function pickSiteDomain() {
  var link = $(".desk_hdr_nav_categories a[data-href-wl][data-href-cb]").eq(0).attr("data-href-wl");
  if (typeof link !== undefined && link) {
    return matchRegex(link, "www.([a-zA-Z.-]*)\/")[0];
  }
}


function dinamizLink() {
  //-- init
  var site_domain_wl = pickSiteDomain();
  var site_domain_cb = "cashback." + site_domain_wl;

  var subdomain_cb = "";
  var subdomain_wl = "";
  var notProd = false;

  //-- set subdomain_cbs if exists
  if (isStage()) {
    if (isCashbackSite()) {
      subdomain_cb = "stage.";
      subdomain_wl = "qa-gl.";
    }
    else {
      subdomain_cb = "stage.";
      subdomain_wl = "stage.";
    }
    notProd = true;
  }
  else if (isQaGl()) {
    if (isCashbackSite()) {
      subdomain_cb = "qa-gl.";
      subdomain_wl = "qa-gl.";
    }
    else {
      subdomain_cb = "stage.";
      subdomain_wl = "qa-gl.";
    }
    notProd = true;
  }
  else if (isQa()) {
    if (isCashbackSite()) {
      subdomain_cb = "qa.";
      subdomain_wl = "qa.";
    }
    else {
      subdomain_cb = "stage.";
      subdomain_wl = "qa.";
    }
    notProd = true;
  }



  //-- if not on prod,
  if (notProd) {
    $("a:not(.prodlink)").each(function() {


      var replaced = false;
      var href = $(this).attr("href"); //its original href

      //-- if the link has an href attribute (yeah... it happened)
      if (typeof href !== "undefined") {

          //-- update WL links
          var parts = href.split("www");
          var protocol = parts[0];
          if (protocol.length < 101) {
            var link = parts[1];
            var pos = href.indexOf(site_domain_wl); //testing if the site exists in the url
            if (typeof(link) != "undefined") {
              if ((pos !== -1 || typeof site_domain_wl === "undefined") && !link.match( /(cashback)/)) {
                $(this).attr("href", protocol + subdomain_wl+ "www" + link);
                replaced = true;
              }
            }

            //-- update CB links
            if (!replaced) {
              parts = href.split("cashback.");
              protocol = parts[0];
              link = parts[1];
              href = href.indexOf(site_domain_cb); //testing if the CB site exists in the url
              if (typeof(link) != "undefined") {
                if (href !== -1) {

                  $(this).attr("href", protocol + subdomain_cb+ "cashback." + link);
                  replaced = true;
                }
              }
            }
          }
      }
    });

    //-- partner search case
    $("form.partner-search").each(function() {

      var replaced = false;
      var url = $(this).attr("data-base-url"); //its original data-base-url

      var parts = url.split("cashback.");
      var protocol = parts[0];
      var link = parts[1];
      if (typeof(link) != "undefined") {
        $(this).attr("data-base-url", protocol + subdomain_cb+ "cashback." + link);
        replaced = true;
      }
    });
  }
}

//-- exec
dinamizLink();
